export const FETCH_SCHOOL_REQUEST = 'FETCH_SCHOOL_REQUEST';
export const FETCH_SCHOOL_SUCCESS = 'FETCH_SCHOOL_SUCCESS';
export const FETCH_SCHOOL_FAILURE = 'FETCH_SCHOOL_FAILURE';


export const FETCH_ALL_DATA_REQUEST = 'FETCH_ALL_DATA_REQUEST';
export const FETCH_ALL_DATA_SUCCESS = 'FETCH_ALL_DATA_SUCCESS';
export const FETCH_ALL_DATA_FAILURE = 'FETCH_ALL_DATA_FAILURE';

export const FETCH_EMAIL_ADDRESSES_REQUEST = 'FETCH_EMAIL_ADDRESSES_REQUEST';
export const FETCH_EMAIL_ADDRESSES_SUCCESS = 'FETCH_EMAIL_ADDRESSES_SUCCESS';
export const FETCH_EMAIL_ADDRESSES_FAILURE = 'FETCH_EMAIL_ADDRESSES_FAILURE';
